export const SET_NAVIGATE = 'SET_NAVIGATE';
export const RESET_NAVIGATE = 'RESET_NAVIGATE';